import { Box, Stack, styled } from '@mui/material';

export interface ThemeStyles {
  backgroundColor: string;
  color: string;
}

interface KeyContainerBoxProps {
  themestyles: ThemeStyles;
}

export const KeyContainerBox = styled(Box)((props: KeyContainerBoxProps) => ({
  ...props.themestyles,
  ...{
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.16)',
    padding: '12px 32px 12px 20px',
    gap: '10px'
  }
}));

interface KeySetStackProps {
  addverticalpadding: boolean;
}

export const KeySetStack = styled(Stack)((props: KeySetStackProps) => ({
  paddingBottom: props.addverticalpadding ? '12px' : '0'
}));

export const KeyNameBox = styled(Box)(() => ({
  padding: '0 12px',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '16px',
  letterSpacing: '0.4px'
}));

interface KeyColorBoxProps {
  iconcolor: string;
}

export const KeyColorBox = styled(Box)((props: KeyColorBoxProps) => ({
  backgroundColor: props.iconcolor,
  display: 'inline-block',
  height: '16px',
  width: '16px',
  borderRadius: '50%',
  marginLeft: '4px'
}));
